module.exports = __webpack_public_path__ + "twitter-share-7f23bb1f821ba9438b5b.svg";